import React from 'react'
import { Checkbox_, Input_, Kotak, Select_, TitleBar } from '@/services/Forms/FormsSatu'
import { UploadOutlined } from '@ant-design/icons'
import { Checkbox, Form, Radio, Select } from 'antd'
import MainLayouts from 'layouts/MainLayouts'
import { Col, Row } from 'react-bootstrap'
import { Date_ } from 'services/Forms/Forms'
import { Button_, Switch_ } from 'services/Forms/FormsSatu'
import { msg } from 'services/Toastr/Notify/_Toastr'
function ChecklistPolaMakan() {


    const listMakanan = [
        { id: 1, jeniskamakan: "Beras", name: "beras" },
        { id: 2, jeniskamakan: "Jagung", name: "jagung" },
        { id: 3, jeniskamakan: "Mie", name: "mie" },
        { id: 4, jeniskamakan: "Roti", name: "roti" },
        { id: 5, jeniskamakan: "Biskuit/Kue", name: "biskuit_kue" },
        { id: 6, jeniskamakan: "Kentang", name: "kentang" },
        { id: 7, jeniskamakan: "Singkong", name: "singkong" },
        { id: 8, jeniskamakan: "Ubi Rambat", name: "ubi_rambat" },
        { id: 9, jeniskamakan: "Tempe", name: "tempe" },
        { id: 10, jeniskamakan: "Tahu", name: "tahu" },
        { id: 11, jeniskamakan: "Oncom", name: "oncom" },
        { id: 12, jeniskamakan: "Kacang Kering", name: "kacang_kering" },
        { id: 13, jeniskamakan: "Ayam", name: "ayam" },
        { id: 14, jeniskamakan: "Daging", name: "daging" },
        { id: 15, jeniskamakan: "Daging awet", name: "daging_awet" },
        { id: 16, jeniskamakan: "Hati/Limpa/Otak/Usus/Paru", name: "hati_limpa_otak_usus_paru" },
        { id: 17, jeniskamakan: "Telur ayam/Bebek", name: "telur_ayam_bebek" },
        { id: 18, jeniskamakan: "Ikan basah", name: "ikan_basah" },
        { id: 19, jeniskamakan: "Ikan kering", name: "ikan_kering" },
        { id: 20, jeniskamakan: "Udang basah", name: "udang_basah" },
        { id: 21, jeniskamakan: "Sayuran hijau", name: "sayuran_hijau" },
        { id: 22, jeniskamakan: "Sayur kacang-kacangan", name: "sayur_kacang_kacangan" },
        { id: 23, jeniskamakan: "Sayuran/tomat/wortel", name: "sayuran_tomat_wortel" },
        { id: 24, jeniskamakan: "Pisang", name: "pisang" },
        { id: 25, jeniskamakan: "Pepaya", name: "pepaya" },
        { id: 26, jeniskamakan: "Jeruk", name: "jeruk" },
        { id: 27, jeniskamakan: "Buah segar lain", name: "buah_segar_lain" },
        { id: 28, jeniskamakan: "Buah diawet", name: "buah_diawet" },
        { id: 29, jeniskamakan: "Susu segar", name: "susu_segar" },
        { id: 30, jeniskamakan: "Susu kental manis", name: "susu_kental_manis" },
        { id: 31, jeniskamakan: "Susu kental tak manis", name: "susu_kental_tak_manis" },
        { id: 32, jeniskamakan: "Susu tepung whole", name: "susu_tepung_whole" },
        { id: 33, jeniskamakan: "Susu tepung skim", name: "susu_tepung_skim" },
        { id: 34, jeniskamakan: "Keju", name: "keju" },
        { id: 35, jeniskamakan: "Minyak/goreng-gorengan", name: "minyak_goreng_gorengan" },
        { id: 36, jeniskamakan: "Kelapa/santan", name: "kelapa_santan" },
        { id: 37, jeniskamakan: "Margarin/mentega", name: "margarin_mentega" },
        { id: 38, jeniskamakan: "Teh manis", name: "teh_manis" },
        { id: 39, jeniskamakan: "Kopi manis", name: "kopi_manis" },
        { id: 40, jeniskamakan: "Sirop", name: "sirop" },
        { id: 41, jeniskamakan: "Minuman botol ringan", name: "minuman_botol_ringan" },
        { id: 42, jeniskamakan: "Minuman beralkohol", name: "minuman_beralkohol" },
    ]


    const listPolaMakan = [
        { id: 1, label: "Lebih 1 x Sehari", },
        { id: 2, label: "1 x Sehari", },
        { id: 3, label: "3-6 x Seminggu", },
        { id: 4, label: "1-2 x Seminggu", },
        { id: 5, label: "Kurang 1 x Seminggu", },
        { id: 6, label: "Tidak Pernah", },
    ]




    return (
        <Kotak label="Pola Makan (Beri tanda centang pada salah satu)">
            <Row className=' b p-2' style={{ width: "98%" }}>
                <Col sm="3" className='text-kanan'> Jenis Makanan </Col>
                {
                    listPolaMakan.map(e => (
                        <Col key={e.id}> {e.label} </Col>
                    ))
                }
            </Row>
            <div style={{overflow :"auto"}}>
                <div style={{ height: "500px", minWidth: "700px", }} className='border' >
                    {
                        listMakanan.map((e, f, i) => (
                            <Row key={f} className='hover border-bottom  ' style={{ width: "98%" }}>
                                <Col sm="3" className='kanan text-uppercase text-dark b ' style={{ textAlign: "right", paddingTop: "5px", }}>  {e.jeniskamakan}. {f + 1} </Col>
                                {
                                    listPolaMakan.map((j, k, l) => (
                                        <Col key={k} style={{ paddingLeft: "30px", height: "30px", }}>
                                            <Checkbox_ size="large" name={["centang", e.name + "_" + j.id]} />
                                            {/* <Radio name={j.id.toString()} id={j.id}>{j.id}</Radio> */}
                                        </Col>
                                    ))
                                }
                            </Row>
                        ))
                    }
                </div>
            </div>


        </Kotak>
    )
}

export default ChecklistPolaMakan